import { createTranslations } from '@npco/utils-translations'

export const useSubmitInternalTransferTranslations = createTranslations({
  error: 'Your transfer was unsuccessful. Please try again.',
})
